import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.user.initialize');
import { OnInit, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-user-initialize',
template: templateSource || '',
    styles: [``],
})
export class PortalUserInitializeComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;
    @ViewChild('step2FileInput') step2FileInput!: ElementRef<HTMLInputElement>;

    public step = {
        current: 'step1',
        list: ['step1', 'step2', 'step3'],
    };

    public step1 = {
        data: {
            role: 'user',
            status: 'active',
        },
        form: {},
    };

    public step2 = {
        data: {},
        farms: [],
        tab: 'new',
    };

    public step3 = {
        data: {
            installed: moment().format('YYYY-MM-DD'),
            type: 'single',
            direction: 'right',
            tray: [],
            machine_condition: [],
        },
    };

    private debounce = 0;

    public uploadStatus = {
        upload: false,
        upload_process: 0
    };

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    private showModal(message): Promise<boolean> {
        return this.modalMessage.open({ message });
    }

    public async nextStep() {
        const idx = this.step.list.indexOf(this.step.current) + 1;
        if (idx >= this.step.list.length) return;

        this.step.current = this.step.list[idx];

        if (this.step.current === 'step2') {
            await this.initStep2();
        }

        if (this.step.current === 'step3') {
            await this.initStep3();
        }

        await this.service.render();
    }

    private emailValidator(email) {
      if (!email) return false;
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return re.test(email.trim());
    }

    public async checkEmail(email) {

        if (!email) {
            await this.showModal('이메일을 입력해주세요.');
            return;
        }

        if (!this.emailValidator(email)) {
            await this.showModal('올바른 이메일 형식이 아닙니다.');
            return;
        }

        let res;

        try {
            res = await wiz.call('check', { email });
        } catch (err: any) {
            res = err;
        }

        const code = res?.code || res?.status;

        if (code === 409 || code === 401) {

            const ok = await this.showModal(
                '이미 가입된 이메일입니다. 농장 등록으로 이동합니다.'
            );

            if (ok) {
                this.step1.data = { ...this.step1.data, ...res?.data };
                await this.nextStep();
            }

            return;
        }
        
        if (code === 200) {
            await this.showModal('사용 가능한 이메일입니다.');
            this.step1.form.email_ok = true;
            await this.service.render();
            return;
        }
        await this.showModal('이메일 확인 중 오류가 발생했습니다.');
    }

    public checkPassword(password) {
        this.step1.form.password_error =
            !password || password.length < 8
                ? '비밀번호는 8자리 이상이어야 합니다.'
                : null;
    }

    public checkPasswordRepeat(password, repeat) {
        this.step1.form.passwordrepeat_error =
            password !== repeat ? '비밀번호가 일치하지 않습니다.' : null;
    }

    public formatMobile() {
        this.debounce = Date.now();
        setTimeout(() => {
            if (Date.now() - this.debounce < 400) return;

            let hp = this.step1.data.mobile;
            if (!hp) return;

            this.step1.data.mobile = hp
                .replace(/[^0-9]/g, '')
                .replace(
                    /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                    '$1-$2-$3'
                )
                .replace('--', '-');

            this.service.render();
        }, 400);
    }

    public async registUser() {

        const data = { ...this.step1.data };

        if (!data.email) {
            await this.showModal('이메일을 입력해주세요.');
            return;
        }

        if (!this.emailValidator(data.email)) {
            await this.showModal('올바른 이메일 형식이 아닙니다.');
            return;
        }

        if (!this.step1.form.email_ok) {
            await this.showModal('이메일 중복 확인을 해주세요.');
            return;
        }

        if (!data.name || !data.name.trim()) {
            await this.showModal('이름을 입력해주세요.');
            return;
        }

        if (!data.password || data.password.length < 8) {
            await this.showModal('비밀번호를 8자리 이상 입력해주세요.');
            return;
        }

        if (data.password !== data.password_repeat) {
            await this.showModal('비밀번호가 일치하지 않습니다.');
            return;
        }

        const res = await wiz.call('regist_user', data);

        if (res.code === 200) {
            this.step1.data.id = res.data;
            await this.showModal('회원을 등록하였습니다.');
            await this.nextStep();
        } else {
            await this.showModal('회원 정보를 다시 확인해주세요.');
        }
    }

    public async searchPostal() {
        new daum.Postcode({
            oncomplete: async (data) => {
                this.step2.data.postal = data.zonecode;
                this.step2.data.address1 =
                    data.roadAddress || data.jibunAddress;
                await this.service.render();
            },
        }).open();
    }

    public async registFarm() {
        const data = {
            ...this.step2.data,
            user_id: this.step1.data.id,
        };

        if (!data.user_id) {
            await this.showModal('사용자 정보가 입력되지 않았습니다.');
            return;
        }

        if (!data.farm || !data.farm.trim()) {
            await this.showModal('농장명을 입력해주세요.');
            return;
        }

        if (!data.owner || !data.owner.trim()) {
            await this.showModal('농장주를 입력해주세요.');
            return;
        }

        const res = await wiz.call('regist_farm', data);

        if (res.code === 200) {
            this.step2.data.id = res.data;
            await this.showModal('농장정보가 등록되었습니다.');
            await this.nextStep();
        } else {
            await this.showModal('농장 정보 등록에 실패했습니다. 다시 등록해주세요.');
        }
    }

    public selectStep2Tab(tab, farmId?) {
        this.step2.tab = tab;

        if (tab === 'new') {
            this.step2.data = this.getEmptyFarmData();
        } else {
            const target = this.step2.farms.find((farm) => farm.id === farmId) || this.step2.farms[0];
            if (target) {
                this.step2.data = this.normalizeFarmData(target);
            }
        }

        this.service.render();
    }

    public isStep2ExistingTab() {
        return this.step2.tab === 'existing';
    }

    public isStep2ExistingFarmActive(farm) {
        if (this.step2.tab !== 'existing') return false;

        const currentId = String(this.step2.data?.id ?? '');
        const farmId = String(farm?.id ?? farm?.farm_id ?? '');

        return currentId === farmId;
    }

    private getEmptyFarmData() {
        return {
            farm: '',
            owner: '',
            postal: '',
            address1: '',
            address_d: '',
            address2: '',
            tel: '',
            fax: '',
            employee_ko: null,
            employee_en: null,
            files: [],
            livestock_num: '',
            agriculture_num: '',
            ekape_id: '',
            ekape_farm_num: '',
        };
    }

    private normalizeFarmData(data) {
        let files = data?.files || [];
        if (typeof files === 'string') {
            try { files = JSON.parse(files); } catch { files = []; }
        }
        return {
            ...data,
            id: data?.id || data?.farm_id || '',
            farm: data?.farm ?? data?.farm_name ?? '',
            owner: data?.owner ?? data?.farm_owner ?? '',
            files: files,
        };
    }

    private async initStep2() {
        const userId = this.step1.data?.id;

        this.step2.farms = [];
        this.step2.tab = 'new';
        this.step2.data = this.getEmptyFarmData();

        if (!userId) return;

        const res = await wiz.call('farminfo', { user_id: userId });
        if (res.code !== 200) return;

        this.step2.farms = (res.data || []).map((farm) => this.normalizeFarmData(farm));

        if (this.step2.farms.length > 0) {
            this.step2.tab = 'existing';
            this.step2.data = this.normalizeFarmData(this.step2.farms[0]);
        }
    }


    private async initStep3() {
        this.step3.data.machine_condition = [
            { id: 'accumulator', display: 'Accumulator', check: true, src: 'accumulator.png' },
            { id: 'washer', display: 'Washer (세척기)', check: true, src: 'washer.png' },
            { id: 'dryer', display: 'Dryer (건조기)', check: true, src: 'dryer.png' },
            { id: 'orientor', display: 'Orientor', check: true, src: 'orientor.png' },
            { id: 'detecting_cracked', display: 'Candling booth detecting cracked eggs', check: true, src: 'detecting_cracked.png' },
            { id: 'sterilizer', display: 'U.V sterilizer (UV살균기)', check: true, src: 'sterilizer.png' },
            { id: 'transfer', display: 'Transfer', check: true, src: 'transfer.png' },
            { id: 'main_control', display: 'Main Control System(Monitor)', check: true, src: 'main_control.png' },
        ];

        this.step3.data.tray = [];
        for (let i = 0; i < 6; i++) {
            this.step3.data.tray.push({ src: 'trayin.png' });
        }

        const res = await wiz.call('machineid');
        if (res?.code === 200) {
            this.step3.data.id = res.data;
        }

        await this.service.render();
    }

    public async registMachine() {

        const data = {
            ...this.step3.data,
            farm_id: this.step2.data.id,
            installed: moment(this.step3.data.installed)
                .format('YYYY-MM-DD HH:mm:ss'),
            machine_condition: JSON.stringify(this.step3.data.machine_condition),
            tray: JSON.stringify(this.step3.data.tray),
        };

        if (!data.farm_id) {
            await this.showModal('농장 정보가 입력되지 않았습니다.');
            return;
        }

        if (!data.id) {
            await this.showModal('선별기 일련번호가 입력되지 않았습니다.');
            return;
        }

        if (!data.model || !data.model.trim()) {
            await this.showModal('선별기 모델 정보가 입력되지 않았습니다.');
            return;
        }

        try {
            const res = await wiz.call('regist_machine', data);

            if (res.code === 200) {

                await this.showModal(
                    '선별기 정보가 등록되었습니다. 농장 정보 페이지로 이동합니다.'
                );

                location.href = `/admin/farm/info/${data.farm_id}`;
                return;
            }
            await this.showModal('선별기 등록에 실패했습니다. 정보를 확인해주세요.');
        } catch (err) {
            await this.showModal('선별기 등록 중 오류가 발생했습니다.');
        }
    }

    public src(item) {
        return `/assets/images/png/${item}`;
    }

    public upload() {
        const files = this.step2FileInput?.nativeElement?.files;
        if (!files?.length) {
            this.showModal('파일을 선택해주세요.');
            return;
        }

        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file[]', files[i]);
        }

        this.uploadStatus.upload = true;
        this.uploadStatus.upload_process = 0;
        this.service.render();

        const xhr = new XMLHttpRequest();

        xhr.upload.onprogress = (e: any) => {
            if (e.lengthComputable) {
                this.uploadStatus.upload_process =
                    Math.round((e.loaded / e.total) * 10000) / 100;
                this.service.render();
            }
        };

        xhr.onreadystatechange = async () => {
            if (xhr.readyState === 4) {
                this.uploadStatus.upload = false;

                if (xhr.status === 200) {
                    try {
                        const res = JSON.parse(xhr.responseText);
                        if (res.code === 200) {
                            if (!this.step2.data.files) this.step2.data.files = [];
                            (res.data || []).forEach((f: any) => {
                                this.step2.data.files.push(f);
                            });
                            await this.showModal('파일이 업로드되었습니다.');
                        }
                    } catch {}
                }

                if (this.step2FileInput?.nativeElement) {
                    this.step2FileInput.nativeElement.value = '';
                }

                await this.service.render();
            }
        };

        xhr.open('POST', '/wiz/api/portal.user.initialize/upload');
        xhr.send(formData);
    }

    public async deleteFile(file: any) {
        const res = await wiz.call('delete', { src: file.src });
        if (res?.code === 200) {
            this.step2.data.files =
                (this.step2.data.files || []).filter((f: any) => f !== file);
            await this.service.render();
        }
    }

    public rerender() {
        this.service.render();
    }

    public removeTray(item) {
        const idx = this.step3.data.tray.indexOf(item);
        if (idx >= 0) {
            this.step3.data.tray.splice(idx, 1);
        }
        this.service.render();
    }

    public addTray(item) {
        this.step3.data.tray.push(item);
        this.service.render();
    }

    public moveCondition(from, to) {
        const arr = this.step3.data.machine_condition;
        if (!arr) return;
        if (to < 0 || to >= arr.length) return;

        const item = arr.splice(from, 1)[0];
        arr.splice(to, 0, item);

        this.service.render();
    }
}

export default PortalUserInitializeComponent;